// extracted by mini-css-extract-plugin
export default {"grid":"grid_FAuoPKZO","image":"image_fzKvDrP_"};